import { render, staticRenderFns } from "./BroadcastMessages.vue?vue&type=template&id=235ab82c&scoped=true&"
import script from "./BroadcastMessages.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessages.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMessages.vue?vue&type=style&index=0&id=235ab82c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ab82c",
  null
  
)

export default component.exports